import script from "./ConsultationLinkedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultationLinkedPage.vue?vue&type=script&setup=true&lang=js"

import "./ConsultationLinkedPage.vue?vue&type=style&index=0&id=0e8af3f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8af3f6"]])

export default __exports__